const EN_GB = 'en-GB';

export function formatEngagementPercent(rate: number | null | undefined): string {
  if (typeof rate !== 'number' || !Number.isFinite(rate)) return '—';
  return `${(rate * 100).toFixed(1)}%`;
}

export function formatEngagementCount(value: number | null | undefined): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '—';
  return new Intl.NumberFormat(EN_GB, { maximumFractionDigits: 1 }).format(value);
}

export function formatEngagementEquation(
  totalEngagements: number | null | undefined,
  views: number | null | undefined,
  rate: number | null | undefined,
): string | null {
  if (
    typeof totalEngagements !== 'number' ||
    !Number.isFinite(totalEngagements) ||
    typeof views !== 'number' ||
    !Number.isFinite(views) ||
    views <= 0 ||
    typeof rate !== 'number' ||
    !Number.isFinite(rate)
  ) {
    return null;
  }

  return `${formatEngagementCount(totalEngagements)} ÷ ${formatEngagementCount(views)} = ${formatEngagementPercent(rate)}`;
}
